import React from 'react';
import { cn } from './cn.js';

const base =
  'inline-flex items-center justify-center gap-2 rounded-2xl text-sm font-semibold transition-all duration-200 ' +
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ptcm-primary/40 focus-visible:ring-offset-2 ' +
  'disabled:opacity-50 disabled:pointer-events-none ring-offset-ptcm-bg dark:ring-offset-gray-900 ' +
  'active:scale-[0.98] hover:-translate-y-[1px] shadow-ptcm-float';

const variants = {
  default: 'bg-ptcm-primary text-white border border-ptcm-primary hover:bg-ptcm-primary-strong hover:border-ptcm-primary-strong',
  secondary: 'bg-ptcm-mint/70 text-ptcm-ink border border-ptcm-border hover:bg-ptcm-mint dark:bg-gray-800 dark:text-gray-100 dark:border-gray-700 dark:hover:bg-gray-700',
  outline: 'border border-ptcm-border bg-white/80 text-ptcm-ink hover:bg-ptcm-primary-soft/45 hover:border-ptcm-primary/30 dark:border-gray-700 dark:bg-transparent dark:text-gray-300 dark:hover:bg-gray-800 dark:hover:text-gray-100',
  ghost: 'text-ptcm-muted hover:bg-ptcm-panel/80 hover:text-ptcm-ink shadow-none hover:shadow-none dark:text-gray-300 dark:hover:bg-gray-800 dark:hover:text-gray-100',
  destructive: 'bg-ptcm-danger text-white border border-ptcm-danger hover:bg-red-500 hover:border-red-500 dark:shadow-none'
};

const sizes = {
  sm: 'h-9 px-3.5',
  md: 'h-11 px-4',
  l: 'min-h-[42px] px-4 py-2 text-base',
  lg: 'min-h-[50px] px-6 py-3 text-base',
  xl: 'min-h-[58px] px-7 py-4 text-base'
};

export default function Button({
  className,
  variant = 'default',
  size = 'md',
  type = 'button',
  ...props
}) {
  return (
    <button
      type={type}
      className={cn(base, variants[variant], sizes[size], className)}
      {...props}
    />
  );
}

